import { Navigate, useLocation } from "react-router-dom";
import { authRoutes, routes } from "../routes";
import { setRedirectPath } from "../../app/utilities/helpers";

const toAbsolute = (path) => (path.startsWith("/") ? path : `/${path}`);

// A route is only registered as a real page when it has NO childNavs.
// For a parent route, the navigable destination is its first leaf descendant
// (e.g. "/assetOnboarding" -> "/assetOnboarding/onboard").
const firstLeafPath = (route) => {
  if (route.childNavs && route.childNavs.length) {
    for (const child of route.childNavs) {
      const leaf = firstLeafPath(child);
      if (leaf) return leaf;
    }
    return null;
  }
  return route.path ? toAbsolute(route.path) : null;
};

// Map every route path (parent or leaf) to the actual page it should open.
const buildEntries = (list, acc = []) => {
  list.forEach((route) => {
    if (route.path) {
      const prefix = toAbsolute(route.path);
      acc.push({ prefix, target: firstLeafPath(route) || prefix });
    }
    if (route.childNavs) buildEntries(route.childNavs, acc);
  });
  return acc;
};

// Longest prefixes first so the most specific route wins the match.
const ENTRIES = [
  ...buildEntries(routes),
  ...buildEntries(authRoutes),
].sort((a, b) => b.prefix.length - a.prefix.length);

const NotFound = () => {
  const { pathname } = useLocation();

  // Any URL that didn't match a defined route lands here.
  // - "/homesss"        -> "/home"                          (mistyped leaf)
  // - "/assetOnboarding"-> "/assetOnboarding/onboard"    (parent -> first page)
  const match = ENTRIES.find((entry) => pathname.startsWith(entry.prefix));

  if (match) {
    return <Navigate to={match.target} replace />;
  }

  // Capture deep-link/email redirect info before sending the user to auth.
  setRedirectPath();
  return <Navigate to="/auth" replace />;
};

export default NotFound;
